export default function SubmitOnParentSubmit() {
    return {
        restrict: 'A',
        require: ['form', '^^form'],
        link: ($scope, $elem, $attrs, [formCtrl, parentFormCtrl]) => {
            $scope.$watch(() => parentFormCtrl.$submitted, (submitted) => {
                if (submitted) {
                    formCtrl.$setSubmitted();
                }
            });
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/common/directives/submit-on-parent-submit.js